//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { ParameterModel } from './ParameterModel';
  
  export class UpdateParametersModel extends ModelBase {
      static readonly $typeName = 'UpdateParametersModel';
      public parameters: ParameterModel[];
      
  }



// WEBPACK FOOTER //
// ./src/app/businessRule/models/UpdateParametersModel.ts